import React, { useState } from 'react'
import { Stack, Typography, Accordion, AccordionSummary, AccordionDetails } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { features } from './features.data'
import { useUser } from 'store'
import { 
  FeatureCard, 
  ScrollableContent, 
  accordionStyles, 
  accordionSummaryStyles, 
  BorderLine 
} from './styles/features.styles'

const FeaturesSection = () => {
  const { t } = useTranslation()
  const [user] = useUser()
  const [expandedFeatures, setExpandedFeatures] = useState<string[]>([])

  const userFeatures = features.filter(feature => {
    if (feature.role === 'admin') {
      return user?.admin
    }
    return user?.roles?.[feature.role]
  })

  const handleHideDetails = () => {
    setExpandedFeatures([])
  }

  const handleAccordionChange = (featureKey: string) => (event: React.SyntheticEvent, isExpanded: boolean) => {
    setExpandedFeatures(prev => 
      isExpanded 
        ? [...prev, featureKey]
        : prev.filter(key => key !== featureKey)
    )
  }

  return (
    <FeatureCard>
      <Stack spacing={1}>
        <Stack direction="row" justifyContent="space-between" alignItems="center">
          <Typography variant="h6" color="text.body.primary">
            {t('profile.features.title')}
          </Typography>
          <Typography 
            variant="body2" 
            color="grey.400" 
            sx={{ cursor: 'pointer' }}
            onClick={handleHideDetails}
          >
            {t('profile.features.hide_details')}
          </Typography>
        </Stack>

        <BorderLine />

        <ScrollableContent spacing={1}>
          {userFeatures.map((feature) => (
            <Accordion
              key={feature.key}
              expanded={expandedFeatures.includes(feature.key)}
              onChange={handleAccordionChange(feature.key)}
              sx={accordionStyles}
            >
              <AccordionSummary
                expandIcon={<i className="fa-light fa-chevron-down" />}
                sx={accordionSummaryStyles}
              >
                <Stack direction="row" alignItems="center" sx={{ width: '100%' }}>
                  <Typography color="#4d4f5b" fontSize={15}>
                    {t(feature.title)}
                  </Typography>
                  <BorderLine />
                </Stack>
              </AccordionSummary>
              <AccordionDetails>
                <Typography color="text.body.tertiary" fontSize={13}>
                  {t(feature.description)}
                </Typography>
              </AccordionDetails>
            </Accordion>
          ))}
        </ScrollableContent>
      </Stack>
    </FeatureCard>
  )
}

export default FeaturesSection
